module.exports = __webpack_public_path__ + "img/cmp_zhong.26b80a88.png";